import React, { useEffect } from "react";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
	updateConfigurationFileBreadcrumb,
	updateShowSpecialSwitches,
} from "../../../redux/configurationFiles/configurationFilesSlice";
// COMPONENTS
import DefinitionsTable from "./DefinitionsTable";
// AUTHORIZATION
import validatePermission from "../../../utils/validatePermissions";
import UnauthorizedPage from "../../unauthorized/UnauthorizedPage";
// INTERFACES
import { RootState } from "../../../app/store";

const DefinitionsPage = () => {
	// ************************************************ */
	// LOCAL STORAGE AND VARIABLES ******************** */
	const dispatch = useDispatch();
	const { permissions } = useSelector((state: RootState) => state.user);
	const { theme } = useSelector((state: RootState) => state.home);

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************* */
	// USE EFFECT ************************************** */
	useEffect(() => {
		dispatch(updateShowSpecialSwitches(false));
		dispatch(updateConfigurationFileBreadcrumb([]));
	}, []);

	// ************************************************ */
	// COMPONENT ************************************** */
	return (
		<div>
			{validatePermission("definitions", permissions) ? (
				<div>
					{/** HEADER AND STEPER */}
					<div className={`layout__contentPage__${theme}`}>
						<DefinitionsTable />
					</div>
				</div>
			) : (
				<UnauthorizedPage />
			)}
		</div>
	);
};

export default DefinitionsPage;
